module.exports = __webpack_public_path__ + "img/40.77a9c27f.jpg";